import styled from 'styled-components';

type BottomSeparatedProps = {
  spacing?: number;
};
const BottomSeparated = styled.div<BottomSeparatedProps>`
  margin-bottom: ${(props): number => props.spacing || 5}px;
`;

export default BottomSeparated;
